import { Component, OnInit } from '@angular/core';
import { PermitTypeService } from 'app/services/permit-type.service';
import { AlertComponent } from 'app/popup/alert.component';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { ActivatedRoute, Router } from '@angular/router';
import { StatusService } from 'app/services/status.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit {

  form;
  pStatus: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean; 
  isCodeDup = false;
  isIdDup = false;
  selectedDisplay = 3;
  selectedSUI = 3;
  message = null;
  public isLoading = false;
  now = new Date();
  audit = { created: '', updated: '' };
  user = { LastName: '' };
  
  constructor(private statusService: StatusService, private authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,private toastService:ToastNotificationService,
     public utility: UtilityServiceService,private toastr:ToastrService) { }

  ngOnInit() {

    this.initForm();
    this.onChanges();
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    //console.log(this.authWebService.userData);
    this.sub = this.route.params.subscribe(params => {
      if (this.router.url.indexOf('edit') != -1) {
        this.isEdit = true;
        this.lblHeading = 'Edit Status';
        this.btnActionLabel = 'Update';
        const id = +params['id'];
        this.isLoading = true;
        this.statusService.getById(id).subscribe(result => {
          this.pStatus = result;         
          this.isLoading = false;
          (<FormGroup>this.form)
            .setValue({
              id: this.pStatus.id
              , code: this.pStatus.code
              , description: this.pStatus.description
              , status_use_ind: this.pStatus.status_use_ind
              , status_from_rule: this.pStatus.status_from_rule
              , status_to_rule: this.pStatus.status_to_rule
              , status_from: this.pStatus.status_from
              , status_to: this.pStatus.status_to
              , group_code: this.pStatus.group_code
              , sort_order: this.pStatus.sort_order
              , is_active: this.pStatus.is_active
              , display_ind: this.pStatus.display_ind
              , date_created: this.pStatus.date_created
              , date_modified: this.pStatus.date_modified
              , user_created: this.pStatus.user_created
              , user_modified: this.pStatus.user_modified
              , application: (this.pStatus.application) ? this.pStatus.application:null
            }, { onlySelf: true });
          this.audit = this.utility.setAuditAttributes(this.pStatus.date_created, this.pStatus.user_created, this.pStatus.date_modified, this.pStatus.user_modified);
        });       
      } else {
        this.isEdit = false;
        this.lblHeading = 'New Status';
        this.btnActionLabel = 'Save';
        this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName);        
      }


    });
  }


  initForm() {
    this.form = new FormGroup({
      id: new FormControl(this.pStatus.id, Validators.compose([Validators.required, Validators.min(1), this.checkIntegerType]))
      , code: new FormControl(this.pStatus.code, Validators.compose([Validators.required, <any>Validators.maxLength(12)]))
      , description: new FormControl(this.pStatus.description, Validators.compose([<any>Validators.maxLength(100)]))
      , status_use_ind: new FormControl(this.pStatus.status_use_ind, Validators.required)
      , status_from_rule: new FormControl(this.pStatus.status_from_rule, Validators.compose([Validators.maxLength(100)]))
      , status_to_rule: new FormControl(this.pStatus.status_to_rule, Validators.compose([Validators.maxLength(100)]))
      , status_from: new FormControl(this.pStatus.status_from, Validators.compose([this.checkNegative, this.checkIntegerType]))
      , status_to: new FormControl(this.pStatus.status_from, Validators.compose([this.checkNegative, this.checkIntegerType]))
      , group_code: new FormControl(this.pStatus.group_code, Validators.compose([Validators.required,<any>Validators.maxLength(12)]))
      , sort_order: new FormControl(this.pStatus.sort_code, Validators.required)
      , is_active: new FormControl()
      , display_ind: new FormControl(this.pStatus.display_ind, Validators.required)
      , date_created: new FormControl()
      , date_modified: new FormControl()
      , user_created: new FormControl()
      , user_modified: new FormControl()
      , application: new FormControl()
    });
    this.form.patchValue(this.utility.defaults);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit(obj: any) {
    if (this.isCodeDup || this.isIdDup) { return; }
    this.pStatus = obj;   
    this.message = (this.isEdit) ? "Updating Status" : "Adding a new Status";
    if (this.isEdit) {
      this.pStatus.date_modified = new Date().toLocaleString();
      this.pStatus.user_modified = this.user.LastName;
      this.isLoading = true;     
      this.statusService.update(this.pStatus).subscribe(result => {
        this.pStatus = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Update Status', message: `Status ${this.pStatus.code} updated succesfully.`, bold: `${this.pStatus.code}` });
        this.toastService.success(`Status ${this.pStatus.code} updated succesfully.`,'Update Status');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Update Status', message: `Status ${this.pStatus.code} was not updated succesfully.Please contact the system admin if the problem persists.`, bold: `${this.pStatus.code}` });
        this.toastService.error(`Status ${this.pStatus.code} was not updated succesfully.Please contact the system admin if the problem persists.`,'Update Status');
      });
    } else {
      this.pStatus.date_modified = this.pStatus.date_created = new Date().toLocaleString();
      this.pStatus.user_modified = this.pStatus.user_created = this.user.LastName;         
      this.isLoading = true;      
      this.statusService.add(this.pStatus).subscribe(result => {
        this.pStatus = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'New Status', message: `New Status ${this.pStatus.code} added successfully.`, bold: `${this.pStatus.code}` });
        this.toastService.success(`New Status ${this.pStatus.code} added successfully.`,'New Status');

        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'New Status', message: `New Status ${this.pStatus.code} not  added successfully.Please contact the system admin if the problem persists.`, bold: `${this.pStatus.code}` });
        this.toastService.success(`New Status ${this.pStatus.code} not  added successfully.Please contact the system admin if the problem persists.`,'New Status');
      });
    }
  }

  navigate() {
    this.router.navigateByUrl('/status/list');
  }

  onDuplicates(control) {


  }

  onChanges(): void {
    this.form.get('code').valueChanges.subscribe(code => {
      if (code.length > 3) {
        this.statusService.checkByCode(code.trim()).subscribe((result:any) => {
          this.isCodeDup = (result.Status && !this.isEdit) ? true : false;
        }, error => {
          this.isCodeDup = false;

        });
      }
    });

    this.form.get('id').valueChanges.subscribe(id => {
      this.isIdDup = false;
      if (this.isInteger(id)) {
          this.statusService.checkById(id).subscribe((result:any) => {
                this.isIdDup = (result.Status && !this.isEdit) ? true : false;
              }, error => {
                this.isIdDup = false;
           });
          }
      
    });
  }



  onChangeValue() {

  }

  onSelectChange() {

  }

  checkNegative(control: FormControl) {
    let statusValue = control.value;   
    if (statusValue<0) {
      return {
        checked: {
          negative: statusValue
        }
      }
    }
    return null;
  }


  checkIntegerType(control: FormControl) {
    let statusValue = control.value;
    if (statusValue) {
    
      let intValue = /^\d*$/.test(statusValue);     
      if (!intValue && statusValue>0) {
        return {
          checkInt: {
            negative: statusValue
          }
        }
      }
      return null;
    }
  }

  isInteger = (num: any) => { return /^\d*$/.test(num); }

}
